export const smallScreenMaxWidth = 720;
export const mediumScreenMaxWidth = 1030;
export const largeScreenMinWidth = 1031;

export const smallMediaQuery = `(max-width: ${smallScreenMaxWidth}px)`;
export const mediumMediaQuery = `(min-width: ${smallScreenMaxWidth + 1}px) and (max-width: ${mediumScreenMaxWidth}px)`;
export const largeMediaQuery = `(min-width: ${largeScreenMinWidth}px)`;

//TECHDEBT: Our current large screen design makes the navbar wrap if the screen size goes below 1130px or so.  To fix this we break sooner than the medium screen size breakpoint just on the navbar.
export const navHamburgerMenuQuery = '@media(max-width: 1136px)';
